import AnnouncementBar from 'layout/AnnouncementBar';
import FooterLanding from 'layout/Landing/footer/FooterLanding';
import HeaderLanding from 'layout/Landing/header/HeaderLanding';
import Footer from 'layout/footer';
import Header from 'layout/header';

type HeaderModelData = {
  data: HeaderProps;
  model: 'header-nav';
};

type FooterModelData = {
  data: FooterProps;
  model: 'footers';
};

type AnnouncementBarModelData = {
  data: AnnouncementBarProps;
  model: 'announcement-bar';
};

type FooterLandingModelData = {
  data: FooterLandingProps;
  model: 'footers-landing';
};

type HeaderLandingModelData = {
  data: HeaderLandingProps;
  model: 'header-landing';
};

type SectionModelProps =
  HeaderModelData | FooterModelData | AnnouncementBarModelData | FooterLandingModelData | HeaderLandingModelData;

const SectionModel = ({ data, model }: SectionModelProps) => {
  switch (model) {
    case 'announcement-bar':
      return <AnnouncementBar {...data} />;
    case 'footers':
      return <Footer {...data} />;
    case 'header-nav':
      return <Header {...data} />;
    case 'footers-landing':
      return <FooterLanding {...data} />;
    case 'header-landing':
      return <HeaderLanding {...data} />;
    default:
      throw new Error(`Unknown model ${model}`);
  }
};

export default SectionModel;
